<template>
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
        <PageHeader>
            <h1 class="ml-3 text-2xl font-bold text-gray-900 sm:truncate flex flex-row justify-between w-full">
                <span>
                    <span class="flex flex-row">
                        <Loader v-if="isContactsFetchPending"
                                class="-sm m-2"/>
                        <template v-else>
                            Contacts
                        </template>
                    </span>
                    <LangSwitcher />
                </span>
                <span>
                    <button @click.prevent="handleExportContacts" class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-custom-600 hover:bg-custom-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                        Exporter les contacts
                    </button>
                </span>
            </h1>
        </PageHeader>

        <div class="mt-8 lg:max-w-6xl lg:mx-auto">
            <h2 class="ml-3 text-1xl font-bold text-gray-900 sm:truncate flex flex-row justify-between w-full">Contacts</h2>
            <div class="m-4">
                <Search
                    v-model="search"
                    @update:modelValue="handleSearchChange"
                />

                <List
                    :items="contacts"
                    :columns="columns"
                    :desc="desc"
                    @sortBy="handleSortBy"
                />

                <Pagination
                    v-if="lastPage > 1"
                    :current_project="currentPage"
                    :last_page="lastPage"
                    @change="handleChangePage"
                />
            </div>
        </div>
    </main>
</template>

<script>
import PageHeader from "../../components/partials/page-header";
import Loader from "../../components/partials/loader";
import LangSwitcher from "../../components/partials/lang-switcher";
import List from "../../components/partials/list"
import Pagination from "../../components/partials/pagination"
import Search from "../../components/partials/search"

export default {
    data() {
        return {
            search: null,
            desc: false
        }
    },
    beforeMount() {
        this.$store.dispatch('contacts/getList', {includes: ['status']})
    },
    computed: {
        isContactsFetchPending() {
            return this.$store.state.contacts.isContactsFetchPending
        },
        locale() {
            return this.$store.state.config.locale;
        },
        contacts() {
            return this.$store.state.contacts.list;
        },
        lastPage() {
            return this.$store.state.contacts.pagination.last_page
        },
        currentPage() {
            return this.$store.state.contacts.pagination.current_page
        },
        columns() {
            return {
                id: {},
                email: {}
            }
        }
    },
    methods: {
        handleChangePage(page = this.currentPage) {
            this.$store.dispatch('contacts/getList', {
                'page': page,
                'sort_by': this.sort_by,
                'desc': this.desc,
                'search': this.search ? {'email': this.search} : {}
            });
        },
        handleSortBy(type) {
            this.desc = !this.desc;
            this.sort_by = type;

            this.handleChangePage();
        },
        handleSearchChange(search) {
            this.search = search;
            this.handleChangePage();
        },
        handleExportContacts() {
            this.$store.dispatch('contacts/export');
        }
    },
    components: {
        PageHeader,
        Loader,
        LangSwitcher,
        Search,
        List,
        Pagination
    }
}
</script>
